import type { TOC } from '@ember/component/template-only';
import FieldsRadioGroup, {
  type Signature as FieldsRadioGroupSig
} from '../fields-radio-group.gts';
import RadioProvider, {
  type S as RadioProviderSig
} from './basic-radio-group/radio-provider.gts';

interface Signature {
  Args: Pick<
    FieldsRadioGroupSig['Args'],
    | 'current'
    | 'onChange'
    | 'isReadOnly'
    | 'title'
    | 'propertyName'
    | 'translationKey'
    | 'isMandatory'
  > &
    Pick<RadioProviderSig['Args'], 'changeset' | 'disabled'>;
  Element: HTMLDivElement;
  Blocks: {
    default: [RadioProviderSig['Blocks']['default'][0]];
  };
}

const ChangesetFieldsRadioGroup: TOC<Signature> = <template>
  <div class='grouped fields' ...attributes>
    <FieldsRadioGroup
      @title={{@title}}
      @propertyName={{@propertyName}}
      @isMandatory={{@isMandatory}}
    >
      <RadioProvider
        @translationKey={{@translationKey}}
        @changeset={{@changeset}}
        @propertyName={{@propertyName}}
        @isReadOnly={{@isReadOnly}}
        @disabled={{@disabled}}
        as |provider|
      >
        {{yield provider}}
      </RadioProvider>
    </FieldsRadioGroup>
  </div>
</template>;

export default ChangesetFieldsRadioGroup;
